import { createSvgIcon } from '@mui/material';

// Жири. Макет 16×16, масштабовано до сітки MUI 24×24.
export const FatIcon = createSvgIcon(
  <g transform="scale(1.5) translate(4 2.25)">
    <path d="M6.855 10.886V4.029a.6.6 0 0 1 1.2 0v6.857a.6.6 0 0 1-1.2 0Z" />
    <path d="M3.43 10.886V.6a.6.6 0 0 1 1.2 0v10.286a.6.6 0 0 1-1.2 0Z" />
    <path d="M0 10.886V6.772a.6.6 0 0 1 1.2 0v4.114a.6.6 0 0 1-1.2 0Z" />
  </g>,
  'Fat',
);
